import { UfoIcon } from './UfoIcon';

/**
 * author: Michael Irigoyen
 * id D2609FE7-60FE-4372-94A9-7BB3C7AD18DE
 * name ufo
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ufo.svg
 * tags
 */
export const UnidentifiedFlyingObjectIcon = UfoIcon;
export default UnidentifiedFlyingObjectIcon